export const numeric = value => value == null || value === '' || !Number.isFinite(Number(value)) ? null : Number(value);
const metric = (key, label, unit = '', direction = null) => ({ key, label, unit, direction });
export function comparisonColumns(group, rate) {
  const p = rate === 'place2' ? '連対率' : '複勝率';
  const ratePair = (prefix, label) => [metric(`${prefix}_win`, `${label} 勝率`, '%', 'high'), metric(`${prefix}_${rate}`, `${label} ${p}`, '%', 'high')];
  const groups = {
    summary: [...ratePair('overall', '全成績'), metric('weighted_spec', '直近 加重SPEC', '', 'high'), metric('best_spec', '直近 最高SPEC', '', 'high'), metric('ability', '能力評価 / 5', '', 'high'), metric('aptitude', '適性評価 / 5', '', 'high'), metric('condition_trend', '調子傾向'), metric('training', '調教評価')],
    course: [...ratePair('course', '本人 同コース'), metric('sire', '父'), ...ratePair('sire_course', '父 同条件'), ...ratePair('sire_group', '父グループ'), ...ratePair('wet', '道悪')],
    pace: [metric('front_3f', '前半ペース 3F換算', '秒', 'low'), metric('first_corner', '前走 1角番手'), metric('recent_corners', '直近5走 1角番手'), metric('leading_rate', '本人 先行率', '%', 'high'), metric('jockey_leading_rate', '騎手 先行率', '%', 'high'), ...ratePair('leading', '先行時'), metric('closing_stability', '上り安定'), metric('best_last_3f', '近走 上り3F最速', '秒', 'low'), metric('predicted_last_3f', '予想 上り3F', '秒', 'low')],
  };
  return group === 'all' ? Object.values(groups).flat() : groups[group];
}
export function displayMetric(value, column) {
  if (value == null || value === '') return '—';
  if (!column.direction && !column.unit) return String(value);
  const n = numeric(value); return n == null ? '—' : `${n.toFixed(1)}${column.unit}`;
}
export function highlightRanks(horses, column) {
  if (!column.direction) return new Map();
  const values = horses.map(h => ({ no: h.horse_no, n: numeric(h.metrics?.[column.key]) })).filter(x => x.n != null);
  values.sort((a, b) => column.direction === 'low' ? a.n - b.n : b.n - a.n);
  const ranks = new Map(); let prior = null, rank = 0;
  values.forEach((x, i) => { if (x.n !== prior) rank = i + 1; if (rank <= 3) ranks.set(x.no, rank); prior = x.n; });
  return ranks;
}
